<template>
  <div class="corporate-vue">
    <div role="alert" aria-live="assertive" aria-atomic="true" class="sr-only">{{ uiStore.tempErrorMsg || '' }}</div>
    <div role="status" aria-live="polite" aria-atomic="true" class="sr-only">{{ uiStore.tempMsg || '' }}</div>
    <transition name="fromLeft">
      <SideMenu v-if="showSideMenu" />
    </transition>
    <transition name="fade">
      <div
        v-if="showModalBg"
        class="modalBg modalHeight"
        @click="uiStore.closeAllModal()"
      />
    </transition>
    <transition name="fadeSlowOut">
      <TempError v-if="uiStore.tempErrorMsg" />
    </transition>

    <CorporateHeader />
    <main id="main-content" class="main relative">
      <slot />
    </main>
    <transition name="fadeSlowOut">
      <TempMsg v-if="uiStore.tempMsg" />
    </transition>
    <CorporateFooter />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import CorporateHeader from '~/components/body/CorporateHeader.vue';
import CorporateFooter from '~/components/body/CorporateFooter.vue';
import SideMenu from '~/components/menu/SideMenu.vue';
import SiteNotice from '~/components/body/SiteNotice.vue';
import TempError from '~/components/body/TempError.vue';
import TempMsg from '~/components/body/TempMsg.vue';
import { storeToRefs } from 'pinia';
import { useUiStore } from '~/store/ui';
import { useGlobalContentStore } from '~/store/globalContent';
import type { StoryBlokSiteNoticeData } from '#constants/types/storyblok';

const uiStore = useUiStore();
const globalContentStore = useGlobalContentStore();

const { showSideMenu, showModalBg } = storeToRefs(uiStore);

// Creates a css variable for 100vh that works on ios safari
const setWindowHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

const updateWidth = () => {
  uiStore.setIsMobile(window.innerWidth < 1024);
  uiStore.setisTabletPortrait(window.innerWidth > 640 && window.innerWidth < 1024);
};

onMounted(() => {
  setWindowHeight();
  window.addEventListener('resize', setWindowHeight);
  updateWidth();
  window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
  window.removeEventListener('resize', setWindowHeight);
  window.removeEventListener('resize', updateWidth);
  document.body.classList.remove('noScroll');
});
</script>

<style lang="postcss">
.corporate-vue .main {
  min-height: calc(var(--vh, 1vh) * 100 - 275px);
}
</style>
